import type {
	BookmarkIntent,
	IntentClassificationData,
	JiraIntent,
	JobTitleIntent,
	KeywordOrAcronymIntent,
	NaturalLanguageIntent,
	NavContentIntent,
	NavigationalIntent,
	NoneIntent,
	OrgChartIntent,
	PersonIntent,
	TeamIntent,
	TopicIntent,
	VisualIntent,
} from './types';

/**
 * Intent type guards
 */

export const isJiraIntent = (intent: IntentClassificationData): intent is JiraIntent =>
	intent.__typename === 'KnowledgeDiscoveryJiraIntent';

export const isJobTitleIntent = (intent: IntentClassificationData): intent is JobTitleIntent =>
	intent.__typename === 'KnowledgeDiscoveryJobTitleIntent';

export const isKeywordOrAcronymIntent = (
	intent: IntentClassificationData,
): intent is KeywordOrAcronymIntent =>
	intent.__typename === 'KnowledgeDiscoveryKeywordOrAcronymIntent';

export const isNaturalLanguageIntent = (
	intent: IntentClassificationData,
): intent is NaturalLanguageIntent =>
	intent.__typename === 'KnowledgeDiscoveryNaturalLanguageIntent';

export const isNoneIntent = (intent: IntentClassificationData): intent is NoneIntent =>
	intent.__typename === 'KnowledgeDiscoveryNoneIntent';

export const isPersonIntent = (intent: IntentClassificationData): intent is PersonIntent =>
	intent.__typename === 'KnowledgeDiscoveryPersonIntent';

export const isTeamIntent = (intent: IntentClassificationData): intent is TeamIntent =>
	intent.__typename === 'KnowledgeDiscoveryTeamIntent';

export const isTopicIntent = (intent: IntentClassificationData): intent is TopicIntent =>
	intent.__typename === 'KnowledgeDiscoveryTopicIntent';

export const isNavContentIntent = (intent: IntentClassificationData): intent is NavContentIntent =>
	intent.__typename === 'KnowledgeDiscoveryNavContentIntent';

export const isBookmarkIntent = (intent: IntentClassificationData): intent is BookmarkIntent =>
	intent.__typename === 'KnowledgeDiscoveryBookmarkIntent';

export const isNavigationalIntent = (
	intent: IntentClassificationData,
): intent is NavigationalIntent => intent.__typename === 'KnowledgeDiscoveryNavigationalIntent';

export const isOrgChartIntent = (intent: IntentClassificationData): intent is OrgChartIntent =>
	intent.__typename === 'KnowledgeDiscoveryOrgChartIntent';

export const isVisualIntent = (intent: IntentClassificationData): intent is VisualIntent =>
	intent.__typename === 'KnowledgeDiscoveryVisualIntent';
